module.exports = __webpack_public_path__ + "img/image-placeholder-small.1c9a6932.jpg";